var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4964_1657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4331 48.9601L46.1394 55.6055C47.6153 56.3777 49.3389 55.1308 49.0579 53.4965L46.6318 39.4212C46.5205 38.7721 46.7362 38.1106 47.2105 37.6498L57.4907 27.6818C58.6843 26.5249 58.0263 24.5086 56.3765 24.2692L42.1706 22.2156C41.5154 22.1215 40.9492 21.7119 40.6571 21.1209L34.3039 8.31465C33.5667 6.82838 31.4355 6.82838 30.6968 8.31465L24.3437 21.1209C24.0502 21.7119 23.484 22.1201 22.8302 22.2156L8.62432 24.2692C6.97448 24.5073 6.31649 26.5235 7.51005 27.6818L17.7902 37.6498C18.2646 38.1093 18.4802 38.7721 18.3689 39.4212L15.9429 53.4965C15.6605 55.1308 17.3854 56.3777 18.8614 55.6055L31.5677 48.9601C32.1533 48.6543 32.853 48.6543 33.4387 48.9601H33.4331Z",
    fill: "#6F51CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4964_1657",
    x: 6.90039,
    y: 7.19995,
    width: 51.2,
    height: 52.6399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4964_1657"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4964_1657",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarEmpty);
export default __webpack_public_path__ + "static/media/icon-star-empty.e2470ad6b701cda48f788811f5172930.svg";
export { ForwardRef as ReactComponent };